import { BrandChefsMealFormType } from 'models/brand-chefs.model';
import { PrepRequestItem, PrepRequestType } from 'models/prep-request.model';
import { ActiveType, ConversionListFormType, ConversionItemType } from 'models/pricing.model';
import { Dispatch, SetStateAction, createContext, useContext } from 'react';

export type BrandChefsContextType = {
  conversionListFormData: ConversionListFormType[];
  setConversionListFormData: (Value: ConversionListFormType[]) => void;

  itemToEdit: BrandChefsMealFormType[];
  setItemToEdit: Dispatch<SetStateAction<BrandChefsMealFormType[]>>;
  activeRequest: PrepRequestType;
  setActiveRequest: Dispatch<SetStateAction<PrepRequestType>>;

  active: ActiveType | null;
  setActive: (item: ActiveType | null) => void;
  step: number;
  setStep: (value: number) => void;
  selectedConversionItem: ConversionItemType | null;
  setSelectedConversionItem: (item: ConversionItemType | null) => void;
  selectedRequestItem: PrepRequestItem | null;
  setSelectedRequestItem: (item: PrepRequestItem | null) => void;
};

export const BrandChefsContext = createContext({} as BrandChefsContextType);

const useBrandChefsContext = () => {
  const context = useContext(BrandChefsContext);
  return context;
};

export default useBrandChefsContext;
